import React from "react";
class PriceWrapper extends React.Component {
  render() {
    return (
      <>
        <div className="NoInstallation">
          <div>
            <div className="amountRow amountRowMargin">
              <span className="regSpan"> هزینه ارسال :</span>
              <div className="toman">
                <span className="editedTomanSpan">
                  {this.props.costs?.shipping_details?.delivery_cost.toLocaleString()}
                </span>
                <span className="price">تومان</span>
              </div>
            </div>
            <div className="amountRow amountRowMargin">
              <span className="regSpan"> هزینه ایاب و ذهاب :</span>
              <div className="toman">
                <span className="editedTomanSpan">
                  {this.props.costs?.shipping_details?.travel_expenses.toLocaleString()}
                </span>
                <span className="price">تومان</span>
              </div>
            </div>
            <div className="amountRow amountRowMargin">
              <span className="regSpan">هزینه نصب :‌</span>
              <div className="toman">
                <span className="editedTomanSpan">
                  {this.props.costs?.shipping_details?.install_cost.toLocaleString()}
                </span>
                <span className="price">تومان</span>
              </div>
            </div>
            {this.props?.costs?.discount_amount ? (
              <div className="ShowProfit">
                <span className="Text">سود شما از این خرید :</span>
                <div>
                  <span className="Number">
                    {this.props.costs?.discount_amount.toLocaleString()}
                  </span>
                  <span className="Toman">تومان</span>
                </div>
              </div>
            ) : null}
            <div className="Payable">
              <span className="Text">مبلغ قابل پرداخت :</span>
              <div>
                <span className="Number">
                  {this.props.costs?.final_price?.toLocaleString() || 0}
                </span>
                <span className="Toman">تومان</span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PriceWrapper;
